export default __webpack_public_path__ + "static/media/VietnamFlag.063b4980.png";